import CryptoJS from "crypto-js/crypto-js";
import JSEncrypt from "jsencrypt";
export default {
	// 去除字符串中所有的空格
	removeSpace(str) {
		return str ? str.toString().replace(/\s/g,'') : null;
	},
	// 设置站点名称
	setStationName(user,station_name) {
		// console.log(user)
		let text;
		if(user.id == 608 || user.name == "xinjian") {
			let reg1 = new RegExp("美森宝-","g");
			text = station_name.replace(reg1,"");
		}else {
			text = station_name
		}
		return text;
	},
    /*加密*/
    encrypt(JsonStringData) {
        var encrypt = new JSEncrypt();
        const pubkey = `
        -----BEGIN PUBLIC KEY-----
        MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtIN6VhaKndenBV/0BXFK
        1JRlcqws3HDIKuc2ICNSev5Mcwdy+0Rwz9WO6+A4SOW07wRMIpeKUc2LejKT5amQ
        dBnl7+FePhFYFq3RNT6lavGABZlKE+TC8VbCrk1cRgH3GLRf9LYV3ew96l2mg6A5
        a64krYDCrbTKsi1j4gRVjVcBVnq17olOFCeiBZr2IaELbaRxh6HCWnkH05jPKHMH
        aafCsA/eh4sz2Q5LLV7XndvxVRSHq9qL4PLg6erglRKaw1Aao9zcca0e2RA5LmJ3
        FqP75erqEMIRF89smMh7LXo4G/rd2tfZNh9m/EY6Q8gxVkAd1G82DnhjTvsgfg9B
        DwIDAQAB
        -----END PUBLIC KEY-----`;
        encrypt.setPublicKey(pubkey);
        return encrypt.encrypt(JSON.stringify(JsonStringData));
    },
    /*解密*/
    decrypt(StringData) {
        var decrypt = new JSEncrypt();
        const privkey = `
        -----BEGIN PRIVATE KEY-----
        MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQC0g3pWFoqd16cF
        X/QFcUrUlGVyrCzccMgq5zYgI1J6/kxzB3L7RHDP1Y7r4DhI5bTvBEwil4pRzYt6
        MpPlqZB0GeXv4V4+EVgWrdE1PqVq8YAFmUoT5MLxVsKuTVxGAfcYtF/0thXd7D3q
        XaaDoDlrriStgMKttMqyLWPiBFWNVwFWerXuiU4UJ6IFmvYhoQttpHGHocJaeQfT
        mM8ocwdpp8KwD96HizPZDkstXted2/FVFIer2ovg8uDp6uCVEprDUBqj3NxxrR7Z
        EDkuYncWo/vl6uoQwhEXz2yYyHstejgb+t3a19k2H2b8RjpDyDFWQB3UbzYOeGNO
        +yB+D0EPAgMBAAECggEAYDMJSUOuD7xTqEugkh30USHchqY3Kit4oVSixbHNTPqk
        51B6+Gla7YfUKORPWpoAOLjDklPMRRgTUsYNh4E8GIOMxLAIN2+q0DtFmOiP41Rc
        c59jmQJ62X7xNU7I9A4sDyBhWtqHAMPbo0DRcqg6saYWqdhK56PHufjymArTRQTI
        +FtihzlgYvVD766PJKUHJl3TGmx7kYfYfPyNsBQu+as0FPv8T8UkEFleGXaQAzo6
        VUFVBKoBcsRPS62DnWmA1DHKro0olaYV01HkXljEJYfbcvbTthmRQkEquMe0XO6m
        IbQ6wIL4nwBwGpgmR5Tr6oQemP+a+lCqKURifmW9YQKBgQDrzhRwZHKlEpLQiGip
        o/H8/YNN5n8e+F0JKTXD/QoUsbvgmhrJTPa56Loq2gjWs3gMS36CYnh+Lp9WvWkJ
        LFuClMo+VRzINpweYNmux2vwlVcTZ4vJwqXhvG4IroJLZSyN/dnNVIKypraKVuL/
        rDhPRK+MTNxPo/2ydv5+2D4OxwKBgQDD+SiE4QF63rzzHHRRxjQULKExwmph1xjU
        A8m225btbWuR3gQVtuHozFQyP4Lo4ByyRnC5hqrLHzCmRr3r6TZ4O8GEwhfLJZmS
        /w3GUGiDu3Rz12lpiZqZYFFNNTXzO9e4c8DG9SV0atdFB3zRbSDicHDwi3FFbNeS
        AB7oQdKTeQKBgQC4v66N3HViVeoHTkjKWLPY5ntAxo3kouypp8sDMjb6vcIYmETS
        YOWSBQAPYOK57MTqxR9qYmJLYpXerOolkMZlydOnAKJbT0YEGxeSc5ZjWW5uuprw
        SfwTn8GKNcfJ8Iv29+P0lvkLpcixHKAfdzxrBsKPpwyZrT+w2sBMe3orswKBgAS7
        CP1cKRr8MXd04mHu9ObfxOxckxDVjmXfyYi+eEA2+ffFcjfL+FwUQpwL6G8Sqd6r
        0KDJ3WmV0SjSYFdHg+cXGi7IOKbQu4pO2dhFrKAxcDgzpPnFNpQpPQ0uEaVTdnuf
        X7HtzP+obJXf/mVXywlsSW2lEBDq9bEyi4xzuk+RAoGBANBgjihhanBriieGju1Z
        j/P4grPoGhlBSiIQLP0DDtFXCb4Wtm1XMx0k4z+St7dtdYtrf3Wngi6QeqHuxVJ/
        ogRhn1PHMbGDj5qBOqufYVklAX1z55NT2DRw+vS689AZVpsnLSlPeXnNnVjWkkOU
        40zP2IuYQ2tWWpawW5rSZE15
        -----END PRIVATE KEY-----`;
        decrypt.setPrivateKey(privkey);
        return JSON.parse(decrypt.decrypt(StringData));
    },
    /*
     * 排序
     * 从大到小
     * Array.sort(Public.createComprisonFunction(key));
     */
    createComprisonFunction(propertyName) {
        return function(object1, object2) {
            var value1 = object1[propertyName];
            var value2 = object2[propertyName];
            if (value1 < value2) {
                return -1;
            } else if (value1 > value2) {
                return 1;
            } else {
                return 0;
            }
        };
    },
    //从小到大
    createComprisonFunction2(propertyName) {
        return function(object1, object2) {
            var value1 = object1[propertyName];
            var value2 = object2[propertyName];
            if (value1 > value2) {
                return -1;
            } else if (value1 < value2) {
                return 1;
            } else {
                return 0;
            }
        };
    },
    /*传入参数毫秒时间戳*/
    longDataToStr(longTypeDate) {
        var date = new Date(longTypeDate);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        var h = date.getHours();
        h = h < 10 ? "0" + h : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        var Millisecond = date.getMilliseconds();
        minute = minute < 10 ? "0" + minute : minute;
        second = second < 10 ? "0" + second : second;
        return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second + "." + Millisecond;
    },
    /*传入参数毫秒时间戳*/
    longDataToStr2(longTypeDate) {
        var date = new Date(longTypeDate);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        var h = date.getHours();
        h = h < 10 ? "0" + h : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        var Millisecond = date.getMilliseconds();
        minute = minute < 10 ? "0" + minute : minute;
        second = second < 10 ? "0" + second : second;
        return y + "-" + m + "-" + d + " " + h + "-" + minute + "-" + second + "." + Millisecond;
    },
    /*相加*/
    addNum(num1, num2) {
        var r1, r2, m;
        try {
            r1 = num1.toString().split(".")[1].length;
        } catch (e) {
            r1 = 0;
        }
        try {
            r2 = num2.toString().split(".")[1].length;
        } catch (e) {
            r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2));
        let num = Math.round(num1 * m + num2 * m) / m;
        return num;
    },
};